// extracted by mini-css-extract-plugin
export default {"body":"style_body__avDh6","roomy":"style_roomy__LHBZL"};